module.exports = __webpack_public_path__ + "img/营业执照.e7164dd6.jpg";